export interface StatusOption {
  name: string;
  color: string;
}

export enum WorkOrderPersona {
  VENDOR = 'Vendor',
  CP = 'Channel Partner',
  SMB = 'SMB',
  SALES = 'Sales',
}
